import React from "react";

import { Route, Routes } from "react-router-dom";

import useDecodedParams from "Hooks/useDecodedParams";
import { deploymentSizingApiEnabledSelector } from "Reducers/environment/deployment";
import { useAppSelector } from "Store/hooks";

import BranchActionPage from "./branch/BranchPane";
import DeployActionPage from "./deploy";
import MergeActionPage from "./merge/MergePane";
import RedeployActionPage from "./redeploy";
import ResumeActionPage from "./resume";
import SyncActionPage from "./synchronisation/Page";

const EnvironmentActionRoutes = () => {
  const { organizationId, projectId, environmentId } = useDecodedParams<{
    organizationId: string;
    projectId?: string;
    environmentId?: string;
  }>();
  const isSizingApiEnabled = useAppSelector(state =>
    deploymentSizingApiEnabledSelector(state, {
      organizationId,
      projectId,
      environmentId
    })
  );

  return (
    <Routes>
      <Route
        path="sync"
        element={<SyncActionPage isSizingApiEnabled={isSizingApiEnabled} />}
      />
      <Route
        path="merge"
        element={<MergeActionPage isSizingApiEnabled={isSizingApiEnabled} />}
      />
      <Route
        path="branch"
        element={<BranchActionPage isSizingApiEnabled={isSizingApiEnabled} />}
      />
      <Route path="redeploy" element={<RedeployActionPage />} />
      <Route path="deploy" element={<DeployActionPage />} />
      <Route path="resume" element={<ResumeActionPage />} />
      <Route path="resume-now" element={<ResumeActionPage action="now" />} />
    </Routes>
  );
};

export default EnvironmentActionRoutes;
